const Contact = () =>
  import(
    /* webpackChunkName: "site-generator-site-contact" */ '@/pages/site-generator/crm/contact/index.vue'
  )
const CreateContact = () =>
  import(
    /* webpackChunkName: "site-generator-site-contact" */ '@/pages/site-generator/crm/contact/create.vue'
  )
const EditContact = () =>
  import(
    /* webpackChunkName: "site-generator-site-contact" */ '@/pages/site-generator/crm/contact/edit.vue'
  )

export default {
  path: 'contact',
  meta: {
    label: 'contact',
    auth: 'contact'
  },
  component: {
    name: 'Contact',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteContactReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Contact
    },
    {
      name: 'SiteCreateContact',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateContact
    },
    {
      name: 'SiteEditContact',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditContact,
      props: true
    }
  ]
}
